import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TMeetingNote } from '@shared/types/meeting-note';

export type TMeetingNoteQuery = {
  meeting: number;
  o?: 'id' | '-id' | 'created_at' | '-created_at';
  page_number?: number;
  page_size?: number;
};

type TMeetingNotePayload = {
  note: string;
  meeting: number;
  noteId?: number;
};

const meetingNoteApi = createCrudService<
  TMeetingNote,
  TMeetingNoteQuery,
  TMeetingNotePayload
>({
  queryKey: [QUERY_KEYS.getMeetingNotes],
  url: 'meeting-notes',
  validateQuery: [QUERY_KEYS.getLeads],
});

export default meetingNoteApi;
